module.exports = __webpack_public_path__ + "images/emoji/seven.5e8fc13254be0d130c27.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/seven.png
// module id = wnKd
// module chunks = 14